import { useState, useCallback, useEffect } from 'react';

export const useToken = () => {
    const [token, setToken] = useState(() => localStorage.getItem('token'));
    const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('refresh'));
    const [expiresAt, setExpiresAt] = useState(() => localStorage.getItem('expires'));



    const updateToken = useCallback(({ token, refresh, expires } = {}) => {
        if (token) {
            localStorage.setItem('token', token);
            setToken(token);
        }
        if (refresh) {
            localStorage.setItem('refresh', refresh);
            setRefreshToken(refresh);
        }
        if (expires) {
            localStorage.setItem('expires', expires);
            setExpiresAt(expires);
        }
    }, []);

    const isExpiringSoon = useCallback(() => {
        if (!expiresAt) return false;
        const expiration = new Date(expiresAt);
        const now = new Date();
        const diffMinutes = (expiration - now) / 1000 / 60;
        return diffMinutes <= 2;
    }, [expiresAt]);

    const clearToken = useCallback(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        localStorage.removeItem('expires');
        setToken(null);
        setRefreshToken(null);
        setExpiresAt(null);
    }, []);

    const getTokenHeaders = useCallback(() => ({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    }), [token]);

    return {
        token,
        setToken,
        refreshToken,
        expiresAt,
        updateToken,
        clearToken,
        isExpiringSoon,
        getTokenHeaders,
    };
};
